import { createGlobalStyle } from 'styled-components';
import theme from './theme';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    background-color: #FAF3E8;
    color: #5A5247;
    font-family: ${theme.fonts.body};
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  /* Selection highlighting */
  ::selection {
    background-color: rgba(51, 51, 51, 0.2);
    color: ${theme.colors.ink};
  }

  ::-moz-selection {
    background-color: rgba(51, 51, 51, 0.2);
    color: ${theme.colors.ink};
  }

  /* Allow images to be part of selections */
  img {
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    max-width: 100%;
    height: auto;
  }

  /* Allow text selection */
  * {
    -webkit-tap-highlight-color: transparent;
  }
`;

export default GlobalStyle;
